import Entity from '@/models/entities/Entity';
import { Color } from '@/models/entities/Color';

export class ColorGroup implements Entity {
  public id: number = 0;
  public name: string = '';
  public totalColors: number = 0;
  public colors: Color[] = [];

  constructor(initData: Partial<ColorGroup>) {
    Object.assign(this, initData);
  }
}
